import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { vppsAPI } from "../api/api";
import { VppsActionTypes } from "../actions/actionTypes";

function* getVppsUsers(action) {
    try {
        if (action.payload.search === null) {
            yield put({
                type: VppsActionTypes.GET_VPPS_USERS_SUCCESS,
                payload: {
                    users: {
                        results: [],
                        count: 0
                    }
                }
            });
        } else {
            const usersResponse = yield call(() =>
                vppsAPI.getVppsUsers({
                    skip: 0,
                    top: 1000000,
                    search: action.payload.search
                })
            );

            yield put({
                type: VppsActionTypes.GET_VPPS_USERS_SUCCESS,
                payload: {
                    users: usersResponse.data
                }
            });
        }
    } catch (e) {
        API.handleError(e.response, "Error getting Vpps Users.");

        yield put({
            type: VppsActionTypes.GET_VPPS_USERS_FAIL,
            message: e.message
        });
    }
}

export function* getVppsUsersWatcher() {
    yield takeLatest(VppsActionTypes.GET_VPPS_USERS, getVppsUsers);
}
